import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';

const ScheduledMeetings = ({ campList = null, getCampList = null, match }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const Headers = [
    'Meeting Subject',
    'Scheduled Date',
    'Scheduled Time',
    'Meeting Status',
    'Actions',
  ];

  useEffect(() => {
    if (getCampList !== null)
      (async () => {
        setIsLoading(true);
        await getCampList(match.params.siteId);
        setIsLoading(false);
      })();
  }, [getCampList]);

  useEffect(() => {
    const tableData = [
      'id',
      'subject',
      'scheduled_date',
      'scheduled_time',
      'statusName',
    ];
    const data =
      campList?.resultSets?.length &&
      campList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              element.mom_send_status === 'Not Send' &&
              (element.statusName === 'Cancelled' ||
                element.statusName === 'Completed')
                ? [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/conduct-camp/details`,
                    },
                    {
                      name: `${
                        element.is_vendor_allocated
                          ? 'View Allocated Vendor'
                          : 'Allocate Vendor'
                      }`,
                      link: `${baseUrl}/brand-activation/conduct-camp/vendor/${element?.site_id}`,
                    },
                  ]
                : element.statusName === 'Under Approval'
                ? [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/conduct-camp/details`,
                    },
                  ]
                : [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/conduct-camp/details`,
                    },
                    {
                      name: `${
                        element.mom_send_status === 'Not Send'
                          ? localization.createMom
                          : localization.viewMom
                      }`,
                      link: `${
                        element.mom_send_status === 'Not Send'
                          ? `${baseUrl}/brand-activation/conduct-camp/create-minutes-of-meeting/${element?.site_id}`
                          : `${baseUrl}/brand-activation/conduct-camp/view-minutes-of-meeting`
                      }`,
                    },
                    {
                      name: `${
                        element.is_vendor_allocated
                          ? 'View Allocated Vendor'
                          : 'Allocate Vendor'
                      }`,
                      link: `${baseUrl}/brand-activation/conduct-camp/vendor/${element?.site_id}`,
                    },
                    {
                      name: !element.precamp
                        ? localization.preCamp
                        : localization.postCamp,
                      link: !element.precamp
                        ? `${baseUrl}/brand-activation/conduct-camp/pre-camp/${element?.site_id}`
                        : `${baseUrl}/brand-activation/conduct-camp/post-camp/${element?.site_id}`,
                    },
                  ],
          }
        )
      );
    if (campList?.resultSets?.length && data) {
      setListData(data);
    } else {
      setListData([]);
    }
  }, [campList, baseUrl]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={{
            pathname: `${baseUrl}/brand-activation/conduct-camp/meeting/${match?.params?.siteId}`,
            query: { noOfCamp: campList?.resultSets?.length },
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.scheduleCampMeeting}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.campListing}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={campList?.resultSets}
        isId={false}
        srNo={campList?.from}
      />
    </Layout>
  );
};

ScheduledMeetings.propTypes = {
  campList: PropTypes.any,
  getCampList: PropTypes.func,
  match: PropTypes.any,
};

export default ScheduledMeetings;
